import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-prefix-suffix',
  templateUrl: './add-prefix-suffix.component.html',
  styleUrls: ['./add-prefix-suffix.component.scss']
})
export class AddPrefixSuffixComponent implements OnInit {

  constructor(private fb: FormBuilder,public dialogRef: MatDialogRef<AddPrefixSuffixComponent>,) { 
    dialogRef.disableClose = true;
    this.templateForm = this.fb.group({
      prefix: ['',[Validators.maxLength(25)]],
      suffix: ['',[Validators.maxLength(25)]]
    });
  }

  ngOnInit(): void {
  }


  templateForm: FormGroup;
  isTemplateOpen = false;

  onOpenTemp() {
    this.isTemplateOpen = true;
  }


  closeDialog(isSendData?:boolean) {
    if(isSendData){
      this.dialogRef.close(this.templateForm.value);
      return;
    }
    this.dialogRef.close()
  }
}
